import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { IProductConfigurableSelection, IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from 'projects/app-default/src/app/catalog/model/product/product.decorator';
import { BuilderProductConfigurableOptionsComponent } from '../../../product-preview/configurable-options/builder-product-configurable-options.component';
@Component({
    selector: 'builder-product-configurable-selection',
    templateUrl: 'builder-product-configurable-selection.html',
    standalone: true,
    imports: [ImageModule, TranslationModule, PriceComponent, BuilderProductConfigurableOptionsComponent],
    styleUrls: ['./builder-product-configurable-selection.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuilderProductConfigurableSelectionComponent extends ProductComponentDef<LocalProduct<IProductDataV3>> implements OnInit {
    @Input()
    existingSelection?: IProductConfigurableSelection;

    @Output()
    onRemove = new EventEmitter<void>();

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.existingSelection) {
            this.selection = { ...this.existingSelection };
            this.onSelectionChange(this.selection);
        }
    }

    protected remove(): void {
        this.onRemove.emit();
    }
}
